// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/advisor.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message omnios.v1.Engagement
 */
export const Engagement = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Engagement",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "idea", kind: "message", T: Struct },
    { no: 5, name: "context_profile", kind: "message", T: Struct },
    { no: 6, name: "framing", kind: "message", T: Struct },
    { no: 7, name: "lenses", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "stage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "created_at", kind: "message", T: Timestamp },
    { no: 12, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.AdvisorLensOpinion
 */
export const AdvisorLensOpinion = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AdvisorLensOpinion",
  () => [
    { no: 1, name: "round", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "lens", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "verdict", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "one_line", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "full", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.RequesterQuestion
 */
export const RequesterQuestion = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RequesterQuestion",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "round", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "lens", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "question", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "answer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * One document in the engagement's evidence library. Bytes are
 * uploaded via EntityFileService (entity_type="engagement"); this
 * carries the user's description of what the document contains.
 *
 * @generated from message omnios.v1.EngagementDocument
 */
export const EngagementDocument = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EngagementDocument",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "entity_file_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "parse_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreateEngagementRequest
 */
export const CreateEngagementRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateEngagementRequest",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "idea", kind: "message", T: Struct },
    { no: 3, name: "context_profile", kind: "message", T: Struct },
    { no: 4, name: "lenses", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetEngagementRequest
 */
export const GetEngagementRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEngagementRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Engagements are created in draft; documents attach to the draft,
 * then StartEngagement convenes the panel.
 *
 * @generated from message omnios.v1.StartEngagementRequest
 */
export const StartEngagementRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StartEngagementRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.AttachDocumentRequest
 */
export const AttachDocumentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AttachDocumentRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_file_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEngagementDocumentsRequest
 */
export const ListEngagementDocumentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEngagementDocumentsRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEngagementDocumentsResponse
 */
export const ListEngagementDocumentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEngagementDocumentsResponse",
  () => [
    { no: 1, name: "documents", kind: "message", T: EngagementDocument, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListEngagementsRequest
 */
export const ListEngagementsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEngagementsRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEngagementsResponse
 */
export const ListEngagementsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEngagementsResponse",
  () => [
    { no: 1, name: "engagements", kind: "message", T: Engagement, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ApproveGateRequest
 */
export const ApproveGateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApproveGateRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "gate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "approved", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ApproveGateResponse
 */
export const ApproveGateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApproveGateResponse",
  [],
);

/**
 * @generated from message omnios.v1.SubmitEvidenceRequest
 */
export const SubmitEvidenceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SubmitEvidenceRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "evidence", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.SubmitEvidenceResponse
 */
export const SubmitEvidenceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SubmitEvidenceResponse",
  [],
);

/**
 * @generated from message omnios.v1.ListLensOpinionsRequest
 */
export const ListLensOpinionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListLensOpinionsRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "round", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ListLensOpinionsResponse
 */
export const ListLensOpinionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListLensOpinionsResponse",
  () => [
    { no: 1, name: "opinions", kind: "message", T: AdvisorLensOpinion, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListRequesterQuestionsRequest
 */
export const ListRequesterQuestionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListRequesterQuestionsRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListRequesterQuestionsResponse
 */
export const ListRequesterQuestionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListRequesterQuestionsResponse",
  () => [
    { no: 1, name: "questions", kind: "message", T: RequesterQuestion, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetDossierRequest
 */
export const GetDossierRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetDossierRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CancelEngagementRequest
 */
export const CancelEngagementRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CancelEngagementRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CancelEngagementResponse
 */
export const CancelEngagementResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CancelEngagementResponse",
  [],
);

/**
 * Requester agreement at close: the calibration ground truth v1.
 *
 * @generated from message omnios.v1.AssessVerdictsRequest
 */
export const AssessVerdictsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AssessVerdictsRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "assessments", kind: "message", T: VerdictAssessment, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.VerdictAssessment
 */
export const VerdictAssessment = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.VerdictAssessment",
  () => [
    { no: 1, name: "lens", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agree", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.AssessVerdictsResponse
 */
export const AssessVerdictsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AssessVerdictsResponse",
  () => [
    { no: 1, name: "scored", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.AdvisorTension
 */
export const AdvisorTension = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AdvisorTension",
  () => [
    { no: 1, name: "round", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lens_a", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lens_b", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "claim", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "detail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.AdvisorRedFlag
 */
export const AdvisorRedFlag = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AdvisorRedFlag",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "round", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "lens", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "severity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "target", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "claim", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "condition", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "confidence", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListFindingsRequest
 */
export const ListFindingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListFindingsRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListFindingsResponse
 */
export const ListFindingsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListFindingsResponse",
  () => [
    { no: 1, name: "tensions", kind: "message", T: AdvisorTension, repeated: true },
    { no: 2, name: "red_flags", kind: "message", T: AdvisorRedFlag, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdateRedFlagStateRequest
 */
export const UpdateRedFlagStateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateRedFlagStateRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "red_flag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateRedFlagStateResponse
 */
export const UpdateRedFlagStateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateRedFlagStateResponse",
  [],
);

/**
 * @generated from message omnios.v1.AdvisorPersona
 */
export const AdvisorPersona = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AdvisorPersona",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "system_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "prompt_version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "autonomy_level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPersonasRequest
 */
export const ListPersonasRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPersonasRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListPersonasResponse
 */
export const ListPersonasResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPersonasResponse",
  () => [
    { no: 1, name: "personas", kind: "message", T: AdvisorPersona, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePersonaPromptRequest
 */
export const UpdatePersonaPromptRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePersonaPromptRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "system_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePersonaPromptResponse
 */
export const UpdatePersonaPromptResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePersonaPromptResponse",
  () => [
    { no: 1, name: "prompt_version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * The reasoning diary: journaled steps + audited tool calls.
 *
 * @generated from message omnios.v1.AdvisorActivityEntry
 */
export const AdvisorActivityEntry = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AdvisorActivityEntry",
  () => [
    { no: 1, name: "at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "latency_ms", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "token_cost", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "detail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetEngagementActivityRequest
 */
export const GetEngagementActivityRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEngagementActivityRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetEngagementActivityResponse
 */
export const GetEngagementActivityResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEngagementActivityResponse",
  () => [
    { no: 1, name: "entries", kind: "message", T: AdvisorActivityEntry, repeated: true },
  ],
);

/**
 * Translate-at-presentation (RU render of English-internal content).
 *
 * @generated from message omnios.v1.TranslateTextsRequest
 */
export const TranslateTextsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TranslateTextsRequest",
  () => [
    { no: 1, name: "texts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "target_language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.TranslateTextsResponse
 */
export const TranslateTextsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TranslateTextsResponse",
  () => [
    { no: 1, name: "translations", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetCompanyScaffoldRequest
 */
export const GetCompanyScaffoldRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCompanyScaffoldRequest",
  () => [
    { no: 1, name: "engagement_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetCompanyScaffoldResponse
 */
export const GetCompanyScaffoldResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCompanyScaffoldResponse",
  () => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetDossierResponse
 */
export const GetDossierResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetDossierResponse",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "content", kind: "message", T: Struct },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
  ],
);

